// extracted by css-extract-rspack-plugin
export default {"root":"ww6gvz"};